module.exports = __webpack_public_path__ + "img/3-3.25f15418.png";